import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListComponent } from './list.component';
import { ListContentModule } from './list-content.module';
import { ListSideModule } from './list-side.module';
import { ListActionsModule } from './list-actions.module';
import { AvatarModule } from '../avatar/avatar.module';
import { ListTitleModule } from './list-title.module';
import { ListDescriptionModule } from './list-description.module';
import { ListSubtitleModule } from './list-subtitle.module';
@NgModule({
  declarations: [ListComponent],
  imports: [CommonModule, AvatarModule, ListContentModule, ListSideModule, ListActionsModule, ListTitleModule, ListSubtitleModule, ListDescriptionModule ],
  exports: [ListComponent],
})
export class ListModule {}
